import axios from 'axios';

// 获取班级学生列表
export function getStudentList(params) {
  return axios({
    url: '/classRoom/studentList',
    method: 'GET',
    data: params,
  });
}

// 保存数据
export function saveClassSign(data) {
  return axios({
    url: '/classRoom/saveClassSign',
    method: 'POST',
    data: data,
  });
}

// 获取所有小类
export function normList(params) {
  return axios({
    url: '/classRoom/getAllItemList',
    method: 'GET',
    data: params,
  });
}
